import { render, staticRenderFns } from "./CiCase.vue?vue&type=template&id=80233fd8"
import script from "./CiCase.vue?vue&type=script&lang=js"
export * from "./CiCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports